/**
 * Formats seconds into a human-readable time string in the format "Xh Ym Zs"
 * @param totalSeconds - The total number of seconds to format
 * @returns A formatted string like "2h 15m 30s" or "0h 0m 0s" for zero/negative values
 */
export const formatSecondsToHMS = (totalSeconds: number): string => {
  // Handle negative or zero values
  if (totalSeconds <= 0) {
    return '0h 0m 0s';
  }

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  return `${hours}h ${minutes}m ${seconds}s`;
};
